var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"custom-classes-transition","enter-active-class":"animate__animated animate__fadeIn animate__faster","leave-active-class":"animate__animated animate__fadeOut animate__faster"}},[(_vm.show)?_c('div',{attrs:{"id":"intro_box"}},[_c('div',{staticClass:"top",style:({
        height: `${_vm.originalBox.top}px`,
        backgroundColor: `rgba(0, 0, 0, ${
          _vm.config.backgroundOpacity ? _vm.config.backgroundOpacity : 0.9
        })`,
      })}),_c('div',{staticClass:"content",style:({ height: `${_vm.originalBox.height}px` })},[_c('div',{staticClass:"left",style:({
          top: `${_vm.originalBox.top}px`,
          width: `${_vm.originalBox.left}px`,
          height: `${_vm.originalBox.height}px`,
          backgroundColor: `rgba(0, 0, 0, ${
            _vm.config.backgroundOpacity ? _vm.config.backgroundOpacity : 0.9
          })`,
        })}),_c('div',{staticClass:"original-box",style:({
          top: `${_vm.originalBox.top}px`,
          left: `${_vm.originalBox.left}px`,
          width: `${_vm.originalBox.width}px`,
          height: `${_vm.originalBox.height}px`,
        })},[_c('div',{staticClass:"round round-flicker"})]),_c('div',{staticClass:"tip-box",style:(_vm.tipBoxStyle)},[_c('div',{staticClass:"tip-content"},[(_vm.config.tips[_vm.currentIndex].title)?_c('div',{staticClass:"title",style:({
              textAlign: _vm.config.titleStyle
                ? _vm.config.titleStyle.textAlign
                  ? _vm.config.titleStyle.textAlign
                  : 'center'
                : 'center',
              fontSize: _vm.config.titleStyle
                ? _vm.config.titleStyle.fontSize
                  ? _vm.config.titleStyle.fontSize
                  : '19px'
                : '19px',
            })},[_vm._v(" "+_vm._s(_vm.config.tips[_vm.currentIndex].title)+" ")]):_vm._e(),_c('div',{staticClass:"content",style:({
              textAlign: _vm.config.contentStyle
                ? _vm.config.contentStyle.textAlign
                  ? _vm.config.contentStyle.textAlign
                  : 'center'
                : 'center',
              fontSize: _vm.config.contentStyle
                ? _vm.config.contentStyle.fontSize
                  ? _vm.config.contentStyle.fontSize
                  : '15px'
                : '15px',
            })},[_vm._v(" "+_vm._s(_vm.config.tips[_vm.currentIndex].content)+" ")]),_c('div',{staticClass:"action",style:({ justifyContent: 'center' })},[(_vm.currentIndex !== 0)?_vm._t("prev",function(){return [_c('div',{staticClass:"item prev",on:{"click":_vm.prev}},[_vm._v("上一步")])]},{"index":_vm.currentIndex,"tipItem":_vm.config.tips[_vm.currentIndex]}):_vm._e(),(_vm.currentIndex !== _vm.config.tips.length - 1)?_vm._t("next",function(){return [_c('div',{staticClass:"item next",on:{"click":_vm.next}},[_vm._v("下一步")])]},{"index":_vm.currentIndex,"tipItem":_vm.config.tips[_vm.currentIndex]}):_vm._e(),(_vm.currentIndex === _vm.config.tips.length - 1)?_vm._t("done",function(){return [_c('div',{staticClass:"item done",on:{"click":_vm.done}},[_vm._v("完成")])]},{"index":_vm.currentIndex,"tipItem":_vm.config.tips[_vm.currentIndex]}):_vm._e()],2)])]),_c('div',{ref:"tip_box",staticClass:"right",style:({
          top: `${_vm.originalBox.top}px`,
          left: `${_vm.originalBox.left + _vm.originalBox.width}px`,
          width: `calc(100% - ${_vm.originalBox.left + _vm.originalBox.width}px)`,
          height: `${_vm.originalBox.height}px`,
          backgroundColor: `rgba(0, 0, 0, ${
            _vm.config.backgroundOpacity ? _vm.config.backgroundOpacity : 0.9
          })`,
        })})]),_c('div',{staticClass:"bottom",style:({
        height: `calc(100% - ${_vm.originalBox.top}px - ${_vm.originalBox.height}px)`,
        backgroundColor: `rgba(0, 0, 0, ${
          _vm.config.backgroundOpacity ? _vm.config.backgroundOpacity : 0.9
        })`,
      })})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }